import React from 'react'

const SummarySpecReviewWizard = ({ comment, formikSpecReview }: any) => {
    return (
        <div className='row'>
            <div className='col-md-12'>
                <h5 className='mb-3'>Summary </h5>
                <div className='d-flex gap-3'>
                    <p>Comments</p>
                    <p>{comment}</p>
                </div>
                {/* <div className=''>
                    <h5 className='mb-2'>Questions</h5>
                    <div>
                        {formikSpecReview?.values?.surveyQuestions?.map((item: any) => (
                            <div key={item.id}> 
                                <p className='mb-0'>{item?.question}</p>
                                <p className='mb-0'>Answer: {item?.answer?.value}</p>
                            </div>
                        ))}
                    </div>
                </div> */}
            </div>
        </div>
    )
}

export default SummarySpecReviewWizard